import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const ConfirmationDialog = ({ open, handleClose, handleConfirm, title, description, confirmLabel, confirmColorScheme = 'red' }) => {
    const { i18n } = useTranslation();
    const l = (en, ro) => (i18n.language === 'ro' ? ro : en);
    return (
        <Modal isOpen={open} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalBody>
                    <Text>{description}</Text>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={handleClose}>
                        {l('Cancel', 'Anuleaza')}
                    </Button>
                    <Button colorScheme={confirmColorScheme} onClick={handleConfirm}>
                        {confirmLabel || l('Delete', 'Sterge')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationDialog;
